import { Component, OnInit, trigger, state, animate, style, group, transition, keyframes } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { flyIn,fadeIn,createFrame,innerFrame,step1,step2,step3,step4,agreement,inputerror,termserror,error } from './gift.animations';
import { UserService } from '../services/user.service';
import { StoreService } from '../services/store.service';
import { Account } from '../models/account';
import { Product } from '../models/product';
import { Item } from '../models/item';
import { Order } from '../models/order';

@Component({
	selector: 'app-gift',
	templateUrl: './gift.component.html',
	providers: [ StoreService, UserService ],
	animations: [
		flyIn,
		fadeIn,
		createFrame,
		innerFrame,
		step1,
		step2,
		step3,
		step4,
		agreement,
		inputerror,
		termserror,
		error
	]
})
export class GiftComponent implements OnInit {
	

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	giftid: string;
	loggedIn: boolean;

	// Models
	accounts: Account;
	products: Product;
	items: Item;
	order: Order;
	
	// Models
	model = new Login('', '', '');
	newuser = new User();
	gift = new GiftKey('');
	loading = false;
	hasProducts = false;
	hasItems = false;
	oAuthtimer: any;
	state: string = '1';

	// Error handling
	error: string;
	gifterror: string;
	showError = false;
	showsuccess = false;

	constructor(private storeService: StoreService,
  				private userService: UserService,
  				private route: ActivatedRoute,
  				private router: Router,
				private sanitizer : DomSanitizer) { }

	getGiftItems(giftid?) {
		if ( !giftid ) giftid = this.gift.key;
		Promise.resolve(this.storeService.checkKeyItems(giftid)).then((items) => {
			if (items) {
				this.items = items;
				if (items[0]) this.hasItems = true;
			}
		});
	}

	getGiftProducts(giftid?) {
		if ( !giftid ) giftid = this.gift.key;
		Promise.resolve(this.storeService.checkKeyProducts(giftid)).then((products) => {
			if (products) {
				this.products = products;
				if (products[0]) this.hasProducts = true;
			}
		});
	}

	acceptGiftItems(giftid?) {
		if ( this.loggedIn ) {
			if ( !giftid ) giftid = this.gift.key;
			Promise.resolve(this.storeService.addGiftToAccount(giftid)).then((order) => {
				this.order = order;
				if (order[0].code != 200 ) {
					this.gifterror = order[0].err;
					this.showError = true;
					setTimeout( function() { this.showError = false; }, 7000);
				} else if (order[0].code == 200 ){
					this.showError = false;
					this.showsuccess = true;
					setTimeout( function() { this.showsuccess = false; }, 7000);
				}
			});
		}
	}
	

	/**
	* Authorize a logged in user to make a purchase
	**/
	authorize() {
		// Send the authorization request
		this.userService.authorizeUser().subscribe((user) => {
			this.accounts = user;
			if ( user ) {
				this.loggedIn = true;
				this.title = 'Identity Library';
				this.subtitle = 'Add gifts to your account.';
			}
		});
	}

	getGifts() {
		this.hasProducts = false;
		this.hasItems = false;
		this.getGiftItems();
		this.getGiftProducts();
	}

	/* On with the show */
	ngOnInit() {
		this.authorize();
		this.headerHeight = '400px';
		this.giftid = this.route.snapshot.params['id'];

		if (this.giftid) {
			this.getGiftItems(this.giftid);
			this.getGiftProducts(this.giftid);
			this.gift.key = this.giftid;
		}

		this.title = 'Welcome to Identity';
		this.subtitle = 'Collect your gifts by logging into your account.';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
	}

}



/**
 * Models for each form on the page
**/ 

export class GiftKey {
	constructor(
		public key: string
	) {}

}

// This constructor generates the Login form
export class Login {

  constructor(
	public username: string,
	public password: string,
	public token: any
  ) {}

}

// Export the constructor Login form
export class User {

	constructor(
		public username?: string,
		public password?: string,
		public confirmpassword?: string,
		public firstname?: string,
		public surname?: string,
		public email?: string,
		public token?: any,
		public birthday?: any,
		public sex?: string,
		public newsletter?: boolean,
		public terms?: boolean
	) {}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/gift/gift.component.ts